var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporterBasedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1001 4.00075C3.1001 4.84943 3.43724 5.66336 4.03735 6.26347C4.63746 6.86358 5.45138 7.20071 6.30006 7.20071C7.14875 7.20071 7.96267 6.86358 8.56278 6.26347C9.16289 5.66336 9.50003 4.84943 9.50003 4.00075C9.50003 3.15206 9.16289 2.33814 8.56278 1.73803C7.96267 1.13792 7.14875 0.800781 6.30006 0.800781C5.45138 0.800781 4.63746 1.13792 4.03735 1.73803C3.43724 2.33814 3.1001 3.15206 3.1001 4.00075Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.2003V13.6004C1.5 12.7517 1.83714 11.9377 2.43725 11.3376C3.03736 10.7375 3.85128 10.4004 4.69997 10.4004H7.89993",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 13.6L10.3002 15.2L13.5001 12",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporterBasedIc);
export default __webpack_public_path__ + "static/media/reporter_based_ic.eb2a5252c1b3e056019a10befd39fe44.svg";
export { ForwardRef as ReactComponent };